const state = {
	clientsManualToolsStatisticsData: {
		items: [],
		totals: 0
	}
}

export default state
